

export default defineNuxtPlugin(async (nuxtApp) => {

    // return
    const runtimeConfig = useRuntimeConfig()
    let mixpanel = null;

    if (!nuxtApp.$country?.is_india && ![false, 'false'].includes(runtimeConfig.public.mixpanel_token)) {

        const mixpanelModule = await import('mixpanel-browser');
        mixpanel = mixpanelModule.default;

        mixpanel.init(runtimeConfig.public.mixpanel_token, {
            // debug:true,
            track_pageview: true,
            persistence: "localStorage",
        });
    }

    return {
        provide: {
            mixpanel,
        },
    };
});
